import { Table } from "@/Components/Index";
import { useContextProductData } from "@/Context/Product/ContextProductProvider";

const DataDescription = (): JSX.Element => {
  const { Products } = useContextProductData();
  const Productos = Products.map((item) => item)[0];
  return (
    <Table
      longDescription={Productos?.LongDescription ?? ""}
      cTab2Content={Productos?.CTab2Content ?? ""}
    />
  );
};

export default DataDescription;
